import {
    validateEmail,
    validatePhone,
    validateInternationalPostalCode
} from '../Shared/validations.js';
import { copyFor } from '../../copy/copy';

const validateFullName = values => {
    if (values.fullName == null || values.fullName === '') {
        return { fullName: copyFor('validationErrors', 'fullName', 'petition') };
    }
    const split = values.fullName.split(' ');

    if (split.length > 1 && split[0] !== '' && split[1] !== '') return {};

    return { fullName: copyFor('validationErrors', 'fullName', 'petition') };
};

const validateMessage = values => {
    if (values.message == null || values.message === '') {
        return { message: copyFor('validationErrors', 'message', 'petition') };
    }
    return {};
};

const validate = values => {
    const errors = {
        ...validateFullName(values),
        ...validateEmail(values),
        ...validateMessage(values),
        ...validateInternationalPostalCode(values),
        ...validatePhone(values)
    };

    return errors;
};

export default validate;
